import jwtDecode from 'jwt-decode';

export function safeJwtDecode(token) {
  try {
    if (!token || token === 'undefined' || token === 'null') return null;
    return jwtDecode(token);
  } catch (err) {
    console.warn('Invalid JWT:', err);
    return null;
  }
}

export function safeJSONParse(value, fallback = null) {
  try {
    return value ? JSON.parse(value) : fallback;
  } catch (err) {
    console.warn('Failed to parse JSON from localStorage:', err, value);
    return fallback;
  }
}
